module.exports = __webpack_public_path__ + "img/can12.bb91ddaf.png";